import Crud from '../views/Fabricante/Crud'
import Entity from '../views/Fabricante/Add'

let routes = {
    path: '/fabricantes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/fabricantes/add',
            name: 'NewFabricante',
            component: Entity,
            meta: {
                pageTitle: 'Fabricantes',
                breadcrumb: [
                    {
                        text: 'Fabricantes',
                        active: false,
                        to: '/fabricantes',
                    },
                    {
                        text: 'criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/fabricantes/edit/:id?',
            name: 'EditFabricante',
            component: Entity,
            meta: {
                pageTitle: 'Fabricantes',
                breadcrumb: [
                    {
                        text: 'Fabricantes',
                        active: false,
                        to: '/fabricantes',
                    },
                    {
                        text: 'editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/fabricantes',
            name: 'list-fabricantes',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Fabricantes',
                breadcrumb: [
                    {
                        text: 'Fabricantes',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
